import { Component, OnInit, ViewChild, ViewEncapsulation, AfterViewInit, HostListener, ElementRef } from "@angular/core";
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";
import { AllocationDefinitionService } from "../service/allocationdefinition.service";
import { AllocationDefinition } from "../domain/allocationdefinition";
import { GridComponent, Sorts, SortDescriptorModel   } from '@syncfusion/ej2-angular-grids';

@Component({
    templateUrl: "./allocation-definition-table.component.html",
    encapsulation: ViewEncapsulation.None,
})

export class AllocationDefinitionTableComponent implements OnInit ,AfterViewInit {
    private readonly allocationDefinitionRestoreKey = 'allocationDefinitionGridRestore';

    @ViewChild('gridSync') gridSync: GridComponent;
    @ViewChild('definitionGridContainer', { static: false }) definitionGridContainer?: ElementRef<HTMLElement>;

    public filterOptions: Object = { type: 'Excel' };
    public gridHeight = 400;

    cols: any[];
    
    colsSync: any[];

    definitions: AllocationDefinition[];

    sortKey: string;

    sortField: string;

    sortOrder: number;

    timeout: any;

    isDisabled: boolean = false; 
    loadingDefinitions: boolean = false;
    openActionMenuRowId: number | null = null;
    pendingRestoreDefinitionId: number | null = null;
    pendingRestorePageNumber: number | null = null;
    public selectionOptions = {
      type: 'Single',
      mode: 'Row',
      checkboxOnly: false
    };
    public actionColumnAttributes = {
      class: 'allocation-actions-column'
    };

    constructor(
        private AllocationDefinitionService: AllocationDefinitionService,
        private messageService: MessageService,
        private router: Router
    ) {}

    ngOnInit() {
        this.cols = [
            { field: "Id", header: "ID" },
            { field: "AllocationItem", header: "Allocation Item" },
            { field: "SourceDimension", header: "Source Dimension" },
            { field: "SourceDimensionValue", header: "Source Dimension Value" },
            { field: "TargetDimension", header: "Target Dimension" },
            { field: "Description", header: "Description" },
            { field: "OverrideDirectPosting", header: "Override Direct Posting" },
            { field: "ProcessingOrder", header: "Processing Order" },
        ];
this.colsSync = [
    { field: 'id', header: 'ID', width: 200 },
     { field: "AllocationItem", header: "Allocation Item" },
            { field: "SourceDimension", header: "Source Dimension" },
            { field: "SourceDimensionValue", header: "Source Dimension Value" },
            { field: "TargetDimension", header: "Target Dimension" },
            { field: "Description", header: "Description" },
            { field: "OverrideDirectPosting", header: "Override Direct Posting" },
            { field: "ProcessingOrder", header: "Processing Order" },
    // add more columns here as needed
  ];

        this.getDefinitions();

  
    }

   ngAfterViewInit(): void {
  const savedSort = localStorage.getItem('definitionGridSort');
  if (savedSort) {
    const parsed: SortDescriptorModel[] = JSON.parse(savedSort);
    if (parsed?.length) {
      this.gridSync.sortSettings.columns = parsed;
    }
  }

  setTimeout(() => this.updateGridHeight(), 0);
}
    getDefinitions()
    {
        this.loadingDefinitions = true;
        this.AllocationDefinitionService.get(JSON.parse(localStorage.getItem('currentCompany')).id).then((response) => {
            this.definitions = response;
            this.restoreGridStateFromStorage();
            this.loadingDefinitions = false;
            setTimeout(() => this.updateGridHeight(), 0);
        }).catch(() => {
            this.loadingDefinitions = false;
        });
    }

@HostListener('window:resize')
onWindowResize(): void {
  this.updateGridHeight();
}

    viewDefinition(AllocationDefinition: AllocationDefinition) {
        this.storeGridRestoreState(AllocationDefinition?.Id ?? null);
        this.router.navigate(["/allocationfactors", AllocationDefinition.Id]);
    }

    deleteDefinition(AllocationDefinition: AllocationDefinition) {
        if (
            confirm(
                "Please confirm that you want to delete this allocation"
            )
        ) {
            this.isDisabled=true;
            this.AllocationDefinitionService.delete(AllocationDefinition.Id).then(() => {
                this.getDefinitions();
            })
            .then(data=>{
                this.isDisabled=false;
            })
            .catch(error => {
                this.isDisabled=false;
            }); 
;
        }
    }

    createDefinition() {
        this.router.navigate(["/allocationfactors", "new"]);
    }

    onSortChange(event) {
        const value = event.value;

        if (value.indexOf("!") === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

   onActionComplete(args: any): void {
  if (args.requestType === 'sorting') {
    const minimalSortState = this.gridSync.sortSettings.columns.map(col => ({
      field: col.field,
      direction: col.direction
    }));
    localStorage.setItem('definitionGridSort', JSON.stringify(minimalSortState));
  }
}
 
onGridRowDoubleClick(event: any): void {
  const rowData = event.rowData;
  console.log('viewDefinition:', rowData);
  this.viewDefinition(rowData);
}

onGridDataBound(): void {
  this.reselectLastDefinition();
  this.updateGridHeight();
}

onGridRowSelected(args: any): void {
  this.pendingRestoreDefinitionId = null;
  this.pendingRestorePageNumber = null;
}

onActionSelect(event: Event, rowData: any): void {
  const selectedValue = (event.target as HTMLSelectElement).value;
console.log(rowData);
  switch (selectedValue) {
case 'edit':
      this.viewDefinition(rowData);
      break;
    case 'delete':
        console.log('Delete clicked for:', rowData);
      this.deleteDefinition(rowData);
      break;
  }
  // Reset dropdown after selection (optional)
  (event.target as HTMLSelectElement).value = '';
}

onActionMenuClick(action: string, rowData: any, event: MouseEvent): void {
  event.stopPropagation();
  this.closeActionMenu();

  switch (action) {
    case 'edit':
      this.viewDefinition(rowData);
      break;
    case 'delete':
      this.deleteDefinition(rowData);
      break;
  }
}

toggleDropdown(data: any, event: MouseEvent): void {
  event.stopPropagation();
  const rowId = data?.Id ?? data?.id ?? null;
  this.openActionMenuRowId = this.openActionMenuRowId === rowId ? null : rowId;
}

isActionMenuOpen(data: any): boolean {
  const rowId = data?.Id ?? data?.id ?? null;
  return this.openActionMenuRowId === rowId;
}

closeActionMenu(): void {
  this.openActionMenuRowId = null;
}

@HostListener('document:click')
closeAllDropdowns(): void {
  this.closeActionMenu();
}

private storeGridRestoreState(definitionId: number | null): void {
  if (definitionId == null) {
    return;
  }

  const currentPage = Number(this.gridSync?.pageSettings?.currentPage) || 1;
  sessionStorage.setItem(
    this.allocationDefinitionRestoreKey,
    JSON.stringify({
      definitionId: Number(definitionId),
      pageNumber: currentPage
    })
  );
}

private restoreGridStateFromStorage(): void {
  const rawState = sessionStorage.getItem(this.allocationDefinitionRestoreKey);

  if (!rawState) {
    return;
  }

  try {
    const parsedState = JSON.parse(rawState);
    this.pendingRestoreDefinitionId = Number(parsedState?.definitionId);
    this.pendingRestorePageNumber = Number(parsedState?.pageNumber) || 1;
  } catch {
    this.clearRestoreState();
  }
}

private reselectLastDefinition(): void {
  if (!this.gridSync || !this.definitions?.length) {
    return;
  }

  const definitionId = this.pendingRestoreDefinitionId;

  if (definitionId == null) {
    return;
  }

  const targetPage = this.pendingRestorePageNumber || 1;
  const currentPage = Number(this.gridSync.pageSettings?.currentPage) || 1;

  if (currentPage !== targetPage) {
    setTimeout(() => this.gridSync.goToPage(targetPage), 0);
    return;
  }

  this.pendingRestoreDefinitionId = null;
  this.pendingRestorePageNumber = null;
  sessionStorage.removeItem(this.allocationDefinitionRestoreKey);

  const currentViewRecords = this.gridSync.getCurrentViewRecords() as any[];
  const highlightedRowIndex = currentViewRecords.findIndex(
    record => Number(record?.Id ?? record?.id) === Number(definitionId)
  );

  if (highlightedRowIndex >= 0) {
    setTimeout(() => {
      this.gridSync.clearSelection();
      this.gridSync.selectRow(highlightedRowIndex);
    }, 0);
  }
}

private clearRestoreState(): void {
  this.pendingRestoreDefinitionId = null;
  this.pendingRestorePageNumber = null;
  sessionStorage.removeItem(this.allocationDefinitionRestoreKey);
}

private updateGridHeight(): void {
  const containerTop = this.definitionGridContainer?.nativeElement.getBoundingClientRect().top;

  if (containerTop == null) {
    return;
  }

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  const maxAvailableHeight = Math.max(260, viewportHeight - containerTop - 120);
  const visibleRowCount = this.getVisibleDefinitionRowCount();
  const normalizedRowCount = visibleRowCount < 10 ? 10 : visibleRowCount;
  const contentHeight = 120 + (Math.max(normalizedRowCount, 1) * 36) + 48;
  const preferredFillHeight = Math.round(maxAvailableHeight * 0.68) + 16;

  this.gridHeight = Math.max(260, Math.min(maxAvailableHeight, Math.max(contentHeight, preferredFillHeight)));
}

private getVisibleDefinitionRowCount(): number {
  const currentViewRecords = this.gridSync?.getCurrentViewRecords?.() as any[] | undefined;

  if (currentViewRecords?.length) {
    return currentViewRecords.length;
  }

  return this.definitions?.length ?? 0;
}


}
